import React from 'react';
import styles from './BrandingLogo.module.scss';

type BankLogoProps = {
  src: string;
};

const BrandingLogo: React.FC<BankLogoProps> = ({ src }) => (
  <img className={styles.img} width="35%" alt="Branding Logo" src={src} />
);

export default BrandingLogo;
